import { render, staticRenderFns } from "./hotCourseCard.vue?vue&type=template&id=0bbef668&scoped=true&"
import script from "./hotCourseCard.vue?vue&type=script&lang=js&"
export * from "./hotCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./hotCourseCard.vue?vue&type=style&index=0&id=0bbef668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbef668",
  null
  
)

export default component.exports